function resolveCreatedBy(initiatedBy, teammates = []) {
  if (!initiatedBy) return null;
  const initiatedById = String(initiatedBy);
  const teammate = teammates.find((item) => String(item._id) === initiatedById);
  if (teammate) return teammate;
  return { _id: initiatedBy };
}

function resolveSalesChannels(salesChannelIds = [], teamSalesChannels = []) {
  return (salesChannelIds || []).map((channelId) => {
    const match = teamSalesChannels.find(
      (channel) => String(channel._id) === String(channelId),
    );
    return {
      _id: channelId,
      name: (match && match.name) || '',
    };
  });
}

export default function decorateBatchSummaryFromEvent(data = {}, state = {}) {
  const teammates = (state.teammates && state.teammates.items) || [];
  const teamSalesChannels = (state.user && state.user.team && state.user.team.salesChannels) || [];

  return {
    batchId: data.batchId,
    operationType: data.operationType,
    status: data.status,
    total: data.total,
    succeeded: data.succeeded ?? 0,
    warnings: data.warnings ?? 0,
    failed: data.failed ?? 0,
    skipped: data.skipped ?? 0,
    createdBy: resolveCreatedBy(data.initiatedBy, teammates),
    salesChannels: resolveSalesChannels(data.salesChannelIds, teamSalesChannels),
    createdAt: data.createdAt,
  };
}
